import { IconProps, iconA11yProps } from '../types';

export const WarningOutlined = ({ classNames, label }: IconProps) => (
    <svg className={classNames} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 88 75" {...iconA11yProps(label)}>
        <path d="M44.15,55.12c1-.05,1.97,.31,2.7,.99,1.36,1.4,1.36,3.63,0,5.03-.73,.68-1.7,1.03-2.7,.99-.99,.04-1.95-.31-2.67-.99-1.36-1.4-1.36-3.62,0-5.01,.72-.68,1.68-1.04,2.67-1m2.75-3.63h-5.51l-.78-23.16h7.07l-.78,23.16Z" />
        <path d="M86.5,67.44L48.3,3.18c-1.94-3.26-6.66-3.26-8.6,0L1.5,67.44c-1.98,3.33,.42,7.56,4.3,7.56H82.2c3.88,0,6.28-4.22,4.3-7.56Zm-80.7,2.56L44,5.74l38.2,64.26H5.8Z" />
    </svg>
);
